export enum CardItemControlState {
	ENABLED = 'ENABLED',
	DISABLED = 'DISABLED'
}
